import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../../constants/axiosInstance';

export interface NotificationType {
  id: string;
  label: string;
  value: string;
}

export interface NotificationModule {
  id: string;
  label: string;
  value: string;
}

export interface NotificationMetadata {
  sideBarTypes: NotificationType[];
  sideBarModules: NotificationModule[];
}

interface ApiResponse<T> {
  notificationSidebar: T;
  success: boolean;
  message?: string;
}

const NOTIFICATION_SIDEBAR_URL = '/notification/getNotificationSidebar';
const NOTIFICATION_METADATA_QUERY_KEY = 'notificationMetadata';

 export const fetchNotificationMetadata = async (): Promise<NotificationMetadata> => {
  const { data } = await axiosInstance().post<ApiResponse<NotificationMetadata>>(NOTIFICATION_SIDEBAR_URL);
  return data?.notificationSidebar;
};

export const useNotificationMetadata = () => {
  const { data, error, isLoading } = useQuery<NotificationMetadata, Error>({
    queryKey: [NOTIFICATION_METADATA_QUERY_KEY],
    queryFn: fetchNotificationMetadata,
    retry: 2,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });

  return {
    types: data?.sideBarTypes ?? [],
    modules: data?.sideBarModules ?? [],
    error,
    isLoading,
  };
};
